import React from 'react';
import { Link } from 'react-router-dom'
import TextField from 'material-ui/TextField';
import {Row,Col} from 'react-bootstrap'
import RaisedButton from 'material-ui/RaisedButton';

import * as actions from '../../../Actions/signup';
import { connect } from 'react-redux';

class ForgotPassword extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      email:'',
      password: '',
      verifypass: '',
      passMisMatchText: '',
      passValidationText: '',
      passSuccessText: '',
      emailValue: '',
      information: 'deactivate-information',
    };
    this.InformationToggle = this.InformationToggle.bind(this);
    this.forgatPassSubmit=this.forgatPassSubmit.bind(this);
    this.setPassword=this.setPassword.bind(this);
    this.changeEmail=this.changeEmail.bind(this);
    this.setVerifyPassword=this.setVerifyPassword.bind(this);
    
  }

  InformationToggle(){
        let value =  (this.state.information === 'deactivate-information') ? 'active-information' : 'deactivate-information' 
        this.setState({ information : value });
  }
  // forgetpassword submit form
  forgatPassSubmit(e){
    e.preventDefault();

    var email= document.ForgatPassword.email.value;
    var password= document.ForgatPassword.password.value;
    var verifypass= document.ForgatPassword.verifypass.value;

    var validation='true';
    if(email===''){
        this.setState({email:'Please enter an email.'});
        validation='false';
        return false;
    }else{
        this.setState({email:''});
    }
    if(password===''){
        this.setState({passValidationText:'Please enter a password.'});
        validation='false';
        return false;
    }else{
        this.setState({passValidationText:''});
    }
    if(verifypass===''){
        this.setState({passMisMatchText:'Please verify your password.'});
        validation='false';
        return false;
    }else{
        this.setState({passMisMatchText:''});
    }
    if(verifypass!==password){
        this.setState({passMisMatchText:"Password do not match."});
        validation='false';
        return false;
    }else{
        this.setState({passMisMatchText:""});
    }
    
    if(validation==='true' && this.state.passSuccessText!==''){
        this.setState({verifypass:false});
        this.props.restPassword(email,password);
    }
  }

  changeEmail(e){
    let email= e.target.value;
    this.setState({emailValue:email});
  }
  
  setPassword(e){
    let pass= e.target.value;
    if (pass.length < 6) {
        this.setState({passValidationText:"Password is too short."});
    } else if (pass.length > 50) {
        this.setState({passValidationText:"Password is too long."});
    } else if (pass.search(/\d/) === -1) {
        this.setState({passValidationText:"Password must contain letters and numbers."});
    } else if (pass.search(/[a-zA-Z]/) === -1) {
        this.setState({passValidationText:"Password must contain letters and numbers."});
    }else{
      this.setState({passValidationText:""});
      this.setState({passSuccessText:"valid password."});
    }
  }    
  setVerifyPassword(){
    var email= document.ForgatPassword.email.value;
    var password= document.ForgatPassword.password.value;
    var verifypass= document.ForgatPassword.verifypass.value;

    if(verifypass===''){
        this.setState({passMisMatchText:'Please verify your password.'});
    }else{
        this.setState({passMisMatchText:''});
    }
    if(verifypass!==password){
        this.setState({passMisMatchText:"Password do not match."});
    }else{
        this.setState({passMisMatchText:""});
    }
  }
  render() {

      let value=this.props.signUp.forgatPass;
      if(value!==''){
        window.location='/login';
      }
      let urlstring = window.location;
      let getemail =urlstring.toString().split('=',2);
      let email='';
      if(getemail[1]){
        email=getemail[1];
      }
      let today = new Date().getFullYear()

      return(<div>
                <div className="signup-page login">
                     <div className={`signup-right col-6  ${this.state.information}`}>
                        <div className="login-logo">
                            <div className="margin-auto">
                              
                              <h3><Link to ="">Welcome To Dokkit</Link></h3>
                            </div>
                        </div>
                    </div>
                    <div className="signup-left col-6">
                        <div className="show-information vissible-sm vissible-xs"  onClick={this.InformationToggle}>
                          <i className="zmdi zmdi-info"></i>
                        </div>
                        <div className="right-content display-flex">
                             <div className="signup-form-section">
                                  
                                 <form name="ForgatPassword" onSubmit={this.forgatPassSubmit}>
                                    <figure>
                                      <Link to="/">
                                        <img src="/images/dokkit-logo.png" alt="logo-icon" />
                                      </Link>
                                    </figure>
                                    <h3>Enter your new password</h3>
                                     <Row>
                                        <Col md={12}>
                                            <TextField
                                                hintText="Enter Email Id"
                                                fullWidth={ true }
                                                floatingLabelText="User Email"
                                                type="email"
                                                name="email"
                                                errorText={this.state.email}
                                                onChange={this.changeEmail}
                                                value={email?email:this.state.emailValue}
                                                disabled={email?true:false}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <TextField
                                                hintText="Enter Password"
                                                fullWidth={ true }
                                                floatingLabelText="Password *"
                                                type="password"
                                                name="password"
                                                onChange={this.setPassword}
                                                errorText={this.state.passValidationText}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12} className="margb20px">
                                            <TextField
                                                hintText="Re-enter password"
                                                fullWidth={ true }
                                                floatingLabelText="Verify Password *"
                                                type="password"
                                                name="verifypass"
                                                errorText={this.state.passMisMatchText}
                                                onChange={this.setVerifyPassword}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <RaisedButton label="Submit" type="submit" labelColor="#fff" fullWidth={false} />
                                        </Col>
                                    </Row>
                                  </form>
                             </div>   
                             <div className="copyright-footer">
                                <p>&copy; {today.toString()} Dokkit All rights reserved.</p>
                             }
                             </div>       
                        </div>   
                    </div>
                </div>       
             </div>    
      )
    }
}

const mapStateToProps= (state,props)=> {
    return {
      signUp : state.signup
    };
}

export default connect(mapStateToProps,actions)(ForgotPassword);


// WEBPACK FOOTER //
// ./src/Components/Modules/LoginSignup/ForgotPassword.js